export type OptionalPageAndSizeRequest = {
  page?: number,
  size?: number,
}
export type OptionalSortingRequest = {
  sort?: string
  sortAscending?: boolean;
}

export type BasePageableRequest = OptionalPageAndSizeRequest & OptionalSortingRequest & {
  filters?: any,
}

export enum SortingType {
  ASC = 'asc',
  DESC = 'desc',
}

export const DEFAULT_PAGE_RESPONSE = {
  content: [],
  totalPages: 0,
  totalElements: 0,
  size: 0,
  number: 0,
  numberOfElements: 0,
  status: 0,
  sort: null,
};

export const DEFAULT_STATUS_PAGE_RESPONSE = {
  content: [],
  filteredContent: [],
  totalPages: 0,
  totalElements: 0,
  size: 0,
  number: 0,
  numberOfElements: 0,
  hasMorePages: false,
};
